import api from './api';

export interface Relatorio {
  id: string;
  arquivo: string;
  dataGeracao: string;
  visibleInPortal: boolean;
  ticketId: string;
  faturaId: string | null;
  ticket: {
    id: string;
    codigo: string;
    titulo: string;
  };
  fatura?: {
    id: string;
    numero: number;
    valorTotal: string;
  } | null;
}

export const relatorioService = {
  async list(): Promise<Relatorio[]> {
    const response = await api.get<Relatorio[]>('/relatorios');
    return response.data;
  },

  async view(id: string): Promise<void> {
    try {
      const response = await api.get(`/relatorios/${id}/view`, {
        responseType: 'blob',
      });
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Erro ao visualizar relatório:', error);
      alert('Erro ao visualizar relatório. Tente novamente.');
    }
  },

  async download(id: string, filename?: string): Promise<void> {
    try {
      const response = await api.get(`/relatorios/${id}/download`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename || 'relatorio');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Erro ao baixar relatório:', error);
      alert('Erro ao baixar relatório. Tente novamente.');
    }
  },
};
